import { BaseEntity } from 'yt-ng-framework';

export class StatusRo extends BaseEntity {
    constructor() {
        super();
    }
    Naziv: string = null;
    Privremen:boolean=null;
    IdeUObracun:boolean=null;


    Deserialize(input: any) {
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.Privremen=input.Privremen;
        this.IdeUObracun=input.IdeUObracun;
        return this;
    }

    Serialize(input: StatusRo) {
        return input;
    }
}
